import { authenticatedAjax, REQUEST } from "src/co/sura/config/ajax-wrapper";
import { AnyAction } from "redux";
import { 
    CONSULTAR_DATOS_TRABAJADOR, 
    datosTrabajadorConsultados, 
    DATOS_TRABAJADOR_CONSULTADOS, 
    ERROR_CONSULTANDO_DATOS_TRABAJADOR, 
    errorConsultadoDatosTrabajador,
    errorAutorizacionConsultaDatosTrabajador,
    ERROR_AUTORIZACION_CONSULTA_DATOS_TRABAJADOR
} from "./trabajadoresActions";
import { Trabajador } from "../../modelo/Trabajador";

export const consultarDatosTrabajadorEpic = action$ =>
    action$.ofType(CONSULTAR_DATOS_TRABAJADOR)
    .mergeMap((action: any) => {
        const url = `afiliaciones/independientes/datos?dniEmpleador=${action.dniEmpleador}&dniIndependiente=${action.dniIndependiente}&id=${action.id}`;

        return authenticatedAjax
            .get(
                url
            ).map((response) => {
                const respuesta = JSON.parse(response.response);
                return datosTrabajadorConsultados(parseDatosTrabajador(respuesta));
            })
            .catch(response => {
                if (response.status === 401 || response.status === 403) {
                    return [errorAutorizacionConsultaDatosTrabajador()];
                }
                return [errorConsultadoDatosTrabajador()];
            });
    });

export const trabajadoresReducer = ( state = {
    estado: REQUEST.NONE,
    trabajador: undefined
}, action: AnyAction) => {
    switch(action.type) {
        case CONSULTAR_DATOS_TRABAJADOR:
            return {
                ...state,
                estado: REQUEST.PENDING,
                trabajador: undefined
            };
        case DATOS_TRABAJADOR_CONSULTADOS:
            return {
                ...state,
                estado: REQUEST.SUCCESS,
                trabajador: action.trabajador
            }; 
        case ERROR_CONSULTANDO_DATOS_TRABAJADOR:
            return {
                ...state,
                estado: REQUEST.ERROR,
                trabajador: undefined
            };
        case ERROR_AUTORIZACION_CONSULTA_DATOS_TRABAJADOR:
            return {
                ...state,
                estado: REQUEST.FORBIDDEN,
                trabajador: undefined
            };
        default: 
            return state;
    }
};

const parseDatosTrabajador = (respuestaHttp: Trabajador): Trabajador => {
    const datosTrabajador: Trabajador = {
            documento: respuestaHttp.documento,
            nombreCompleto: respuestaHttp.nombreCompleto.toUpperCase(),
            telefono: respuestaHttp.telefono,
            correo: respuestaHttp.correo.toLowerCase(),
            genero: respuestaHttp.genero === 'M' ? "Masculino" : "Femenino",
            fechaNacimiento: respuestaHttp.fechaNacimiento,
            ingresoMensual: respuestaHttp.ingresoMensual,
            totalIngresos: respuestaHttp.totalIngresos,
            inicioContrato: respuestaHttp.inicioContrato,
            finalContrato: respuestaHttp.finalContrato ? respuestaHttp.finalContrato : 'NO DEFINIDO',
            afp: respuestaHttp.afp ? respuestaHttp.afp : 'NINGUNA',
            eps: respuestaHttp.eps ? respuestaHttp.eps : 'NINGUNA',
            provinciaDomicilio: respuestaHttp.provinciaDomicilio,
            ciudadDomicilio: respuestaHttp.ciudadDomicilio,
            datosAfiliacion: {
                actividadEconomica: respuestaHttp.datosAfiliacion.actividadEconomica.length <= 226 ? 
                    respuestaHttp.datosAfiliacion.actividadEconomica : respuestaHttp.datosAfiliacion.actividadEconomica.substring(0, 226)+"...",
                cdActividadEconomica: respuestaHttp.datosAfiliacion.cdActividadEconomica,
                tasaCotizacion: respuestaHttp.datosAfiliacion.tasaCotizacion,
                claseRiesgo: respuestaHttp.datosAfiliacion.claseRiesgo,
                tipoAfiliado: respuestaHttp.datosAfiliacion.tipoAfiliado,
                inicioCobertura: respuestaHttp.datosAfiliacion.inicioCobertura,
                finCobertura: respuestaHttp.datosAfiliacion.finCobertura,
                preafiliacion: respuestaHttp.datosAfiliacion.preafiliacion,
                dniEmpleador: respuestaHttp.datosAfiliacion.dniEmpleador,
                nombreEmpleador: respuestaHttp.datosAfiliacion.nombreEmpleador.toUpperCase(),
                poliza: respuestaHttp.datosAfiliacion.poliza,
                estado: respuestaHttp.datosAfiliacion.estado,
                dniGestion: respuestaHttp.datosAfiliacion.dniGestion,
                fechaGestion: respuestaHttp.datosAfiliacion.fechaGestion,
                tipoCotizante: respuestaHttp.datosAfiliacion.tipoCotizante
            },
            datosCentroTrabajo: respuestaHttp.datosCentroTrabajo
    };
    return datosTrabajador;
};


// WEBPACK FOOTER //
// ./src/co/sura/dominio/reportes/modulos/trabajadores/trabajadoresReducers.ts